import { Popover, PopoverProps } from '../Popover'

export const Modal = (props: PopoverProps) => <Popover {...props} />
